<template>
    <div class="player-container">
        <Component
            :is="driverComponent"
            :data="video.player_data"
            @videoStarted="videoStartedHandler"
            @videoEnded="videoEndedHandler"
            @videoAppend="videoAppendHandler"
            @videoRemove="videoRemoveHandler"
            @videoPriority="videoPriorityHandler"
            @videoMute="videoMuteHandler"
            :poster="backgroundImage"
            :title="movie.name"
            :subtitle="movie.description"
            ref="chunk"
            in-viewport-root-margin="-30% 0%"
        />

        <div class="vjs-volume" @click="videoMuteHandler()" v-if="showVolumeDesktop">
            <i 
                class="fab fah fa-lg fas" 
                :class="{ 
                    'fa-volume-mute': muted, 
                    'fa-volume-up': !muted
                }" aria-hidden="true"></i>
        </div>

        <div class="vjs-volume-mobile" v-if="showVolumeMobile && (propagateStartShowing || propagateEndShowing)">
            <i 
                class="fab fah fa-lg fas" 
                :class="{ 
                    'fa-volume-mute': muted, 
                    'fa-volume-up': !muted,
                    'anim-start': propagateStartShowing,
                    'anim-end': propagateEndShowing
                }" aria-hidden="true"></i>
        </div>
    </div>
</template>
<script>
import ErrorPlayer from './Error.vue';
import { UserVideoConfig } from '../../modules/video/UserVideoConfig';
/*
import LoadingPlayer from './VideoPlayer.Loading';

const generatePlayerComponent = () => ({
    component: import(path),
    loading: LoadingPlayer,
    error: ErrorPlayer,
    delay: 200,
    timeout: 3000,
});*/

import inViewport from 'vue-in-viewport-mixin';

const FULL_ANIMATION_DURATION = 1; // In seconds

export default {
    mixins: [inViewport],
    components: {
        //DemoPlayer: () => import('./VideoPlayer.Demo'),
        ErrorPlayer,
        ChunkedPlayer: () => import('./Chunked'),
    },
    props: {
        video: {
            type: Object,
            required: true,
        },
        showOverlay:{
            type: Boolean,
            required: false,
            default: false
        },
        movie: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            showVolumeDesktop: UserVideoConfig.isDesktop,
            showVolumeMobile: UserVideoConfig.isMobile,
            propagateStartShowing: false,
            propagateEndShowing: false,
            timeout: null,
            ElementHandler: this.$parent.$parent.$parent.getVideoElementHandler()   // This is a hack to get the parent component
        }
    },
    computed: {
        driverComponent(){
            switch(this.video.encode_driver) {
                case 'pro_chunked':     return 'ChunkedPlayer';
                case 'trailer_chunked': return 'ChunkedPlayer';
                case 'free_chunked':    return 'ChunkedPlayer';
                case 'cloudflare':      return 'ChunkedPlayer';
                
                default: return 'ErrorPlayer';
            }
        },
        backgroundImage(){
            const img = this.movie.public_thumbnail_image_path['large'];
            // const img = '/img/video-w.jpg';

            return img;
        },
        muted() {
            return UserVideoConfig.muted;
        }
    },
    mounted(){
    
    },
    watch: {
        driverComponent(val){
            // console.log(val);
            if(val === 'ErrorPlayer'){
                console.error(`No se reconoce el player: ${this.video.encode_driver}`);
            }
        },
        'inViewport.now': function(visible) {
            if (!visible) this.pausePlayer();
 		}
    },
    methods: {
        videoEndedHandler(){
            this.$emit('videoEnded', this.video);
        },
        videoStartedHandler(){
            this.$emit('videoStarted', this.video);
        },
        videoAppendHandler(handler) {
            this.ElementHandler.videoAppendHandler(this.movie, handler);
        },
        videoRemoveHandler() {
            this.ElementHandler.videoRemoveHandler(this.movie);
        },
        videoPriorityHandler(handler) {
            this.ElementHandler.videoHardAppendHandler(this.movie, handler);
        },
        videoMuteHandler() {
            this.ElementHandler.videoMuteHandler();

            // Start animation block
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
                this.propagateStartShowing = false;
                this.propagateEndShowing = false;
            }

            this.propagateStartShowing = true;
            this.timeout = setTimeout(() => {
                this.propagateStartShowing = false;
                this.propagateEndShowing = true;

                this.timeout = setTimeout(() => {
                    this.propagateEndShowing = false;
                }, FULL_ANIMATION_DURATION / 2 * 1000);
            }, FULL_ANIMATION_DURATION / 2 * 1000);
            // End animation block
        },
        playPlayer() {
            this.$refs.chunk.playPlayer();
        },
        pausePlayer() {
            if (!this.$refs.chunk) return;
            this.$refs.chunk.unsetVideo();
        },
    },
    beforeDestroy() {
        if (this.timeout) clearTimeout(this.timeout);
    }
}
</script>

<style scoped lang="scss">
.player-wrapper {
    width: 100%;
    .player{
        width: 100%;
    }
}

.player-container{
    position: relative;
    
    .corner{
        position: absolute;
        z-index: 10;
        top: 0;
        right: 0;
        width: auto;
        height: auto;
    }
    
    .overlay{
        display: none;
        color: #ffffff;
        z-index:9;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        
        &.visible{
            display:block;
        }
    }
}

.vjs-volume, .vjs-volume-mobile {
    position: absolute;
    bottom: 1em;
    right: 1em;
    background-color: white;
    width: 2em;
    height: 2em;
    display: flex;
    justify-content: center;
    border-radius: 100%;
    cursor: pointer;

    i {
        font-size: 1em;
        color: black;
        vertical-align: middle;
        text-align: center;
        margin-block: auto;
    }
}

.vjs-volume-mobile {
    bottom: calc(50% - 2em / 2);
    right: calc(50% - 2em / 2);
    background-color: unset;
    cursor: unset;

    i {
        font-size: 2.5em;
        color: white;
        text-shadow: 0px 0px 5px black;

        animation-duration: 0.5s;
    
        &.anim-start {
            animation-name: appear;
        }

        &.anim-end {
            animation-name: disappear;
        }
    }
}

@keyframes appear {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes disappear {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
</style>
<style lang="scss">
.vjs-menu-button-popup.active{
    .vjs-menu{
        display: block;
    }
}
</style>